import React, { useMemo, useState } from 'react';
import styles from './NavLayout.module.scss';
import { LessonLibraryEnum } from '@types';
import { IconStandalone, IconMyCollection } from '@src/constants';
import { LordIcon } from '@src/components/lord-icon/lord-icon';
import Button from '@src/components/button/Button';
import SearchIcon from 'src/assets/icons/new_search.svg?react';
import ProgramDescription from '@src/components/program-description/ProgramDescription';

type Props = {
  studyMode: string;
  handleSelectPlanMode?: (studyMode: any) => void;
  handleFilterClick?: () => void;
  filters?: any[];
  showFilterMenu?: boolean;
  isAUuser?: boolean;
  isHasLessonLibrary?: boolean;
};

const getIconByType = (type: LessonLibraryEnum) => {
  switch (type) {
    case LessonLibraryEnum.Library:
      return IconStandalone;
    case LessonLibraryEnum.Programs:
      return IconMyCollection;
    default: {
      return IconStandalone;
    }
  }
}

function NavLayout(props: Props) {
  const { studyMode, filters, handleSelectPlanMode, handleFilterClick, showFilterMenu, isAUuser, isHasLessonLibrary } = props;
  const [hoveredTab, setHoveredTab] = useState(-1);

  const _filtered = useMemo(() => {
    // Default order: Programs then Standalone Lessons (aka Lesson Library)
    // If user doesn't have lesson library access, only show Programs.
    const menus: LessonLibraryEnum[] = isHasLessonLibrary
      ? [LessonLibraryEnum.Programs, LessonLibraryEnum.Library]
      : [LessonLibraryEnum.Programs];

    return isAUuser ? [...menus].reverse() : menus;
  }, [isAUuser, isHasLessonLibrary]);

  return (
    <>
      <div className={styles.navView} style={{ opacity: showFilterMenu ? '0' : '1' }}>
        <div className={styles.navInnerView}>
          {_filtered.map((item, index) => {
            const Icon = getIconByType(item as LessonLibraryEnum);
            return (
              <div key={index} className={styles.itemWrapper} onClick={() => handleSelectPlanMode?.(item)} onMouseOver={() => setHoveredTab(index)} onMouseLeave={() => setHoveredTab(-1)}>
                <div className={[styles.listItem, (studyMode === item) ? styles.selItem : ''].join(' ')}>
                  <LordIcon src={Icon} isHover={true} colors={{ primary: studyMode === item || index === hoveredTab ? '#FFB073' : '#FFFFFF', secondary: studyMode === item || index === hoveredTab ? '#FFB073' : '#FFFFFF' }} target='.NavLayout_itemWrapper__bMNcg' size={62} />
                  <div className={[styles.listTitle, studyMode === item ? styles.selItemTitle : ''].join(' ')}>
                    {item === "Lesson Library" && isAUuser ? 'Standalone Lessons' : item}
                  </div>
                </div>
              </div>
            )
          })}
          {studyMode === LessonLibraryEnum.Library ?
            <div className={styles.filterRegion}>
              {filters && filters?.length > 0 ? <div className={styles.badge} /> : null}
              <Button
                className={styles.filterButton}
                size='small'
                label='Search'
                leftIcon={<SearchIcon className={styles.filterIcon} />}
                onClick={handleFilterClick}
              />
            </div> : null
          }
        </div>
      </div>
      <ProgramDescription programName={studyMode} />
    </>
  );
}

export default NavLayout;
